import React, { Fragment, useContext, useEffect, useState, useRef, memo, useCallback, useReducer } from "react";
import { _O } from "../../../modules/utils";
import { closeLayerFn, openAlertPopup, openLayerFn } from "../../Layout";

import _ICON_AUTH_LOCATION from "../../../resources/images/icon/icon_midcir_gray01.png";
import _ICON_AUTH_CAMERA from "../../../resources/images/icon/icon_midcir_gray02.png";
import _ICON_AUTH_PHOTO from "../../../resources/images/icon/icon_midcir_gray03.png";
import _ICON_AUTH_SAVE from "../../../resources/images/icon/icon_midcir_gray04.png";
import { getCookie } from "../../../modules/utils/cookie";

export default (props) => {
    const {registToAttctNo} = props;
    // 취소버튼 -> 약관동의로 변경
    const returnTermsPopup = () => {
        closeLayerFn($("#authPopup"));
        openLayerFn($("#termsPopup"));
    }

    const goCertification = () => {
        console.log("### signUpChannel : " + getCookie('signUpChannel'));
        if(getCookie('signUpChannel') === "000") {
            closeLayerFn($("#authPopup"));
            _O.Open("/membership/certification");
        } else {
            closeLayerFn($("#authPopup"));
            closeLayerFn($("#termsPopup"));
            if(registToAttctNo) {
                registToAttctNo(0);
            } else {
                console.log("? : ", registToAttctNo);
                _O.Open("/membership/certification");
            }
            // openLayerFn($("#inputPopup"));
        }
        $("input[type=checkbox]").prop("checked",false);
        $(".all-check-box a").toggleClass("on");
    }

    return(
        <div className="white-layer-box" id="authPopup" style={{display:"none"}}>
            <div className="wlb-blind"></div>
            <div className="layer-wrap">
                <div className="incont">
                    <div className="tit">앱이용을 위한 권한 안내입니다.</div>
                    
                    <div className="use-guide-cirlist">
                        <span>선택 접근 권한</span>

                        <ul>
                            <li>
                                <img src={_ICON_AUTH_LOCATION} alt="" />
                                <p>
                                    <span>위치</span>
                                    현재의 위치를 기준으로 의료기관 위치정보 표시
                                </p>
                            </li>
                            <li>
                                <img src={_ICON_AUTH_CAMERA} alt="" />
                                <p>
                                    <span>카메라</span>
                                    사진촬영을 통한 등록기능
                                </p>
                            </li>
                            <li>
                                <img src={_ICON_AUTH_PHOTO} alt="" />
                                <p>
                                    <span>사진</span>
                                    저장된 개인자료의 사진 자동저장 및 등록기능 
                                </p>
                            </li>
                            <li>
                                <img src={_ICON_AUTH_SAVE} alt="" />
                                <p>
                                    <span>저장</span>
                                    서비스 이용을 위한 사진 및 파일 저장기능
                                </p>
                            </li>

                        </ul>

                        <p>앱이용을 위한 선택적 접근권한으로 휴대폰{'>'}메뉴{'>'}설정에서 변경이 가능합니다.</p>
                    </div>
                
                    <div className="bot-btn">
                        <a onClick={returnTermsPopup} className="gray">취소</a>
                        <a onClick={(e) => goCertification()}>확인</a>
                        {/* <a onClick={(e) => _O.OpenMenu("/membership/regist")}>확인</a> */}
                    </div>
                </div>
            </div>
        </div>

    )
}